import { ApiService } from '../api.service';
import { Injectable } from '@angular/core';
import { Commande } from '../../models/Commande';

@Injectable({
  providedIn: 'root'
})
export class OperationVenteService {

  constructor(private api: ApiService) { }

  findOperationDualWallet(data: any) {
    return this.api.post('/common/operationDualWallet/find', data);
  }

  saveOperationDualWallet(data: any) {
    return this.api.post('/common/operationDualWallet/makeConvertionNafama', data);
  }

  
}
